import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  clearPosts,
  fetchInstagramMedia,
  fetchStories,
  setStories,
} from "../../Store/instagramSlice";
import { useEffect, useRef, useState } from "react";
import {
  AddFlex,
  DialogHeader,
  Gap,
  PrimaryActionButton,
} from "../../reusableStyles";
import Loader from "../../Pages/Components/Loader";
import styled from "styled-components";
import { THUNK_API_STATES, primaryActionColor } from "../../constants";
import { isArrayNullOrUndefined, isNullOrUndefined } from "../../utils";
import { CircularProgress } from "@mui/material";
import { useInView } from "react-intersection-observer";
import useInstagramIntegrationHook from "../../CustomHooks/useInstagramIntegrationHook";

const Image = styled.img`
  overflow: hidden;
  transition: transform 0.3s ease-in-out; /* Smooth scaling */
  &:hover {
    border-radius: 8px;
    transform: scale(1.2);
  }
`;

const PostsContent = ({
  closeDialog,
  isStory,
  mediaData,
  onClick,
  setMediaData,
}) => {
  const [loading, setLoading] = useState(true);
  const { posts, credentials, stories, otherData } = useSelector(
    (state) => state.instagram
  );
  const dispatch = useDispatch();

  const { ref: lastElementRef, inView } = useInView({
    threshold: 1.0, // Trigger only when the element is fully visible
  });

  console.log(credentials);

  const handleInitial = async () => {
    if (isStory) {
      dispatch(
        fetchStories({
          userId: credentials.user_id,
          accessToken: credentials.access_token,
        })
      ).then((actionResult) => {
        if (actionResult.meta.requestStatus === THUNK_API_STATES.fulfilled) {
          setLoading(false);
        }
      });
      return;
    }
    dispatch(clearPosts()); // Clear posts when the component mounts
    dispatch(
      fetchInstagramMedia({
        userId: credentials.user_id,
        accessToken: credentials.access_token,
      })
    ).then((actionResult) => {
      if (actionResult.meta.requestStatus === THUNK_API_STATES.fulfilled) {
        setLoading(false);
      }
    }); // Fetch initial data
  };

  useEffect(() => {
    handleInitial();
  }, [dispatch, credentials]);

  useEffect(() => {
    if (inView) {
      if (isStory) {
        if (isNullOrUndefined(otherData.nextStoriesSet)) {
          setLoading(false);
          return;
        } else {
          dispatch(
            fetchStories({ paginatedUrl: otherData.nextStoriesSet })
          ).then((actionResult) => {
            if (
              actionResult.meta.requestStatus === THUNK_API_STATES.fulfilled
            ) {
              setLoading(false);
            }
          });
        }
      } else {
        if (isNullOrUndefined(otherData.nextPostsSet)) {
          setLoading(false);
          return;
        } else {
          setLoading(true);
          dispatch(
            fetchInstagramMedia({
              paginatedUrl: otherData.nextPostsSet,
            })
          ).then((actionResult) => {
            if (
              actionResult.meta.requestStatus === THUNK_API_STATES.fulfilled
            ) {
              setLoading(false);
            }
          });
        }
      }
    }
  }, [inView]);

  return (
    <AddFlex flexDirection="column" height="80vh">
      <DialogHeader
        padding={"15px 20px"}
        mainText={"Pick any post or reel to automate"}
        subText={"When someone comments they'll get your custom DM."}
        onClose={closeDialog}
      />
      {!isArrayNullOrUndefined(isStory ? stories : posts) && (
        <AddFlex
          padding="10px"
          gap="10px"
          wrap="wrap"
          height="100%"
          style={{ overflow: "scroll", alignContent: "flex-start" }}
        >
          {(isStory ? stories : posts).map((media, index) => {
            const isLast = (isStory ? stories : posts).length - 1 === index;
            return (
              <div
                ref={isLast ? lastElementRef : null}
                style={{
                  width: "180px",
                  height: "180px",
                  borderRadius: "8px",
                  overflow: "hidden",
                  border:
                    mediaData.mediaId !== media.id
                      ? "2px solid transparent"
                      : `2px solid ${primaryActionColor}`,
                }}
              >
                <Image
                  src={
                    media.media_type === "VIDEO"
                      ? media.thumbnail_url
                      : media.media_url
                  }
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "8px",
                    cursor: "pointer",
                    objectFit: "cover",
                  }}
                  onClick={() => {
                    if (onClick) {
                      return onClick({
                        type: "specific",
                        isMediaUpdated: true,
                        isStory: isStory,
                        mediaId: media.id,
                        media_type: media.media_type,
                        mediaUrl:
                          media.media_type === "VIDEO"
                            ? media.thumbnail_url
                            : media.media_url,
                      });
                    }
                    setMediaData((prev) => ({
                      ...prev,
                      mediaId: media.id,
                      media_type: media.media_type,
                      mediaUrl:
                        media.media_type === "VIDEO"
                          ? media.thumbnail_url
                          : media.media_url,
                    }));
                  }}
                />
              </div>
            );
          })}
        </AddFlex>
      )}
      {loading && (
        <AddFlex margin="20px 0">
          <CircularProgress size={20} sx={{ margin: "0 auto" }} />
        </AddFlex>
      )}
      <Gap />
      <AddFlex padding="10px" style={{ borderTop: "1px solid #ececec" }}>
        <PrimaryActionButton
          onClick={() => {
            closeDialog();
          }}
          style={{ margin: "0 auto" }}
        >
          Done
        </PrimaryActionButton>
      </AddFlex>
    </AddFlex>
  );
};

export default PostsContent;
